function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}

// KeyboardEvent.timeStamp is a DOMHighResTimeStamp in current Chrome and Edge,
// but older engines exposed epoch milliseconds instead. Normalize both forms
// without trusting a timestamp from a different clock or document lifetime.
function normalizeInputTimestampMs(
  rawTimestamp,
  fallbackMs,
  performanceTimeOriginMs,
  performanceNowMs
) {
  const fallback = Number(fallbackMs);
  const safeFallback = Number.isFinite(fallback) ? fallback : Date.now();
  const timestamp = Number(rawTimestamp);
  if (!Number.isFinite(timestamp) || timestamp <= 0) return safeFallback;

  let normalized = timestamp;
  if (timestamp < 1e12) {
    const timeOrigin = Number(performanceTimeOriginMs);
    if (Number.isFinite(timeOrigin) && timeOrigin > 0) {
      normalized = timeOrigin + timestamp;
    } else {
      const performanceNow = Number(performanceNowMs);
      if (Number.isFinite(performanceNow)) {
        normalized = safeFallback - Math.max(0, performanceNow - timestamp);
      }
    }
  }

  if (!Number.isFinite(normalized)) return safeFallback;
  if (Math.abs(normalized - safeFallback) > 4000) return safeFallback;
  return normalized;
}

function inputDispatchDelayMs(eventClientMs, dispatchClientMs, maxBackdateMs) {
  const eventMs = Number(eventClientMs);
  const dispatchMs = Number(dispatchClientMs);
  const maxMs = Math.max(0, Number(maxBackdateMs) || 0);
  if (!Number.isFinite(eventMs) || !Number.isFinite(dispatchMs)) return 0;
  return clamp(dispatchMs - eventMs, 0, maxMs);
}

export {
  normalizeInputTimestampMs,
  inputDispatchDelayMs
};
